import { getClasses } from "../getClasses/getClasses";
import { replaceAll } from "../replaceAll";
export const replaceStringPlaceholder = (text, placeholders, withStyles = true) => {
    if (!text) {
        return "";
    }
    return placeholders.reduce((prev, current) => {
        const props = getClasses([`class="placeholder placeholder-${current.placeholder}"`, current.additionalProps]);
        const { tag = "span", placeholder, value } = current;
        const text = value.toString();
        return replaceAll(prev, `{#${placeholder}#}`, withStyles ? `<${tag} ${props}>${value}</${tag}>` : text);
    }, text);
};
//# sourceMappingURL=replaceStringPlaceholder.js.map